import { render, staticRenderFns } from "./BlockTransactionCard.vue?vue&type=template&id=289316ee&"
import script from "./BlockTransactionCard.vue?vue&type=script&lang=js&"
export * from "./BlockTransactionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports